import { Fragment, ReactElement, useMemo } from 'react';
import { DeathNotificationsNonResidentCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { DeathNotificationsNonResidentSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { DeathNotificationsNonResidentMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { DeathNotificationsNonResidentCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { DeathNotificationsNonResidentCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import PersonSearchDeathNonResidentNotificationShared from 'shell/components/shared/research-notifications/research-death-non-resident/edit-person-search';

interface PersonSearchDeathNonResidentNotificationCivilStatusSharedProps {
  scope?: string;
}

const PersonSearchDeathNonResidentNotificationCivilStatusShared = ({
  scope,
}: PersonSearchDeathNonResidentNotificationCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idCat = params.idCat || undefined;
  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const redirectUrl: string = useMemo(() => {
    return `${goBackUrl}/morte/non-residenti/cancellazione/:idIntestatario/:idSchedaSoggettoANPR`;
  }, [goBackUrl]);

  const items = useMemo(() => {
    if (idCat) {
      return DeathNotificationsNonResidentCivilStatusCrumbs(goBackUrl, idCat);
    }

    if (!scope) {
      return DeathNotificationsNonResidentCrumbs(goBackUrl);
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return DeathNotificationsNonResidentSubscriptionCrumbs(goBackUrl);
      case IdAmbito.Mutazioni:
        return DeathNotificationsNonResidentMutationCrumbs(goBackUrl);
      case IdAmbito.Cancellazioni:
        return DeathNotificationsNonResidentCancellationsCrumbs(goBackUrl);
      default:
        return [];
    }
  }, [scope, idCat]);

  return (
    <Fragment>
      <PersonSearchDeathNonResidentNotificationShared
        goBackUrl={`${goBackUrl}/morte/non-residenti`}
        redirectUrl={redirectUrl}
        items={items}
      />
    </Fragment>
  );
};

PersonSearchDeathNonResidentNotificationCivilStatusShared.displayName =
  'Research Death Non Resident Notifications Page component';

export default PersonSearchDeathNonResidentNotificationCivilStatusShared;
